<template>
    <span v-if="tagsCount>0"
        :data-component-name="$options.name"
    >
        <!-- {{ attributes }} -->
        <q-btn v-bind="$attrs" :round="round">
            <q-menu>
                <q-list dense style="min-width: 100px">
                    <div
                    :key="index"
                    v-for="(label, index) in attributes"
                    >
                        <q-item clickable v-if="label.tags.length>0">
                            <q-item-section>{{ label.name }}</q-item-section>
                            <q-item-section side>
                                <q-icon name="keyboard_arrow_right" />
                            </q-item-section>

                            <q-menu dense auto-close anchor="top right" self="top left">
                                <q-list>
                                    <div>
                                        <q-item
                                            v-for="(tag, n) in label.tags"
                                            :key="n"
                                            clickable
                                            @click="$emit('add-custom-tag', tag)"
                                        >
                                            <q-item-section>{{ tag.name }}</q-item-section>
                                        </q-item>
                                    </div>
                                </q-list>
                            </q-menu>
                        </q-item>
                    </div>
                </q-list>
            </q-menu>
        </q-btn>
    </span>
</template>

<script>
    import { CUSTOMTAGLABELSTAGS } from '@/graphql/tag/queries'
    import orderBy from "lodash/orderBy";

    export default {
        name: "ModelCustomTagsMenu",
        props: {
            tagsModel: {
                type: String,
                default: "PROJECTS"
            },
            customTags: {
                type: Object,
                default(){
                    return {}
                }
            },
            round: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                // attributes: []
            }
        },
        methods: {

        },
        mounted() {
        },
        computed: {
            attributes(){
                if(!this.customTagLabels) return [];
                return orderBy(this.customTagLabels, [item => item.name.toLowerCase()]);
            },
            tagsCount(){
                if(!this.attributes) return 0;
                let tagsCount=0;
                this.attributes.forEach(function(item){
                    tagsCount=tagsCount+item.tags.length
                })
                return tagsCount;
            }
        },
        apollo: {
            customTagLabels: {
                query: CUSTOMTAGLABELSTAGS,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                variables() {
                    return {
                        model: this.tagsModel
                    }
                },
                update(data) {
                    // this.attributes=data.customTagLabels;
                    return data.customTagLabels;
                }
            },
        }
    }
</script>